import * as React from 'react'
import { Tooltip } from 'recharts'
import { cn } from '@/lib/utils'

export const ChartContainer = React.forwardRef(
    ({ className, children, config, ...props }, ref) => {
        const style = React.useMemo(() => {
            if (!config) return undefined

            return Object.entries(config).reduce(
                (acc, [key, value]) => {
                    acc[`--color-${key}`] = value.color
                    return acc
                },
                {}
            )
        }, [config])

        return (
            <div
                ref={ref}
                className={cn('relative flex h-full w-full flex-col', className)}
                style={style}
                {...props}
            >
                {children}
            </div>
        )
    }
)
ChartContainer.displayName = 'ChartContainer'

export function ChartTooltip(props) {
    return <Tooltip {...props} />
}

export function ChartTooltipContent({
    active,
    payload,
    label,
    className,
    formatter,
    labelFormatter,
}) {
    if (!active || !payload?.length) {
        return null
    }

    return (
        <div
            className={cn(
                'min-w-[160px] rounded-md border border-border bg-background/90 p-3 text-sm shadow-lg backdrop-blur',
                className
            )}
        >
            <div className="mb-2 font-medium">
                {labelFormatter ? labelFormatter(label) : label}
            </div>
            <div className="space-y-1">
                {payload.map((item, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between text-sm text-foreground"
                    >
                        <span className="flex items-center gap-2">
                            <span
                                className="h-2.5 w-2.5 rounded-full"
                                style={{ backgroundColor: item.color ?? 'hsl(var(--primary))' }}
                            />
                            {item.name}
                        </span>
                        <span className="text-right font-semibold">
                            {formatter
                                ? formatter(item.value, item.name)
                                : item.value ?? '-'}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}
